import create from './createJsonHook.js';
export default create(localStorage);
//# sourceMappingURL=useLocalStorageJsonValue.js.map